document.addEventListener('DOMContentLoaded', function() {
    const bannerScroller = document.querySelector('.banner-scroller');
    
    if (!bannerScroller) return;
    
    const content = bannerScroller.querySelector('.banner-scroller__content');
    const duplicates = bannerScroller.querySelectorAll('.banner-scroller__duplicate');
    
    // Pause animation on hover
    // bannerScroller.addEventListener('mouseenter', function() {
    //     content.style.animationPlayState = 'paused';
    //     duplicates.forEach(duplicate => {
    //         duplicate.style.animationPlayState = 'paused';
    //     });
    // });
    
    // Resume animation when mouse leaves
    // bannerScroller.addEventListener('mouseleave', function() {
    //     content.style.animationPlayState = 'running';
    //     duplicates.forEach(duplicate => {
    //         duplicate.style.animationPlayState = 'running';
    //     });
    // });
    
    // Adjust animation speed based on content width
    function adjustAnimationSpeed() {
        const contentWidth = content.offsetWidth;
        const containerWidth = bannerScroller.offsetWidth;
        const scrollDistance = contentWidth + containerWidth;
        
        // Calculate duration based on content width (faster for more content)
        const duration = Math.max(20, Math.min(60, scrollDistance / 100));
        
        content.style.animationDuration = `${duration}s`;
        duplicates.forEach(duplicate => {
            duplicate.style.animationDuration = `${duration}s`;
        });
    }
    
    // Adjust speed on load and resize
    adjustAnimationSpeed();
    window.addEventListener('resize', adjustAnimationSpeed);
});
